import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const carMountEquipmentRepository = RepositoryFactory.get("carMountEquipment");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setCarMountEquipment(state, payload) {
    state.data = payload;
  },
  setRegisteredCarMountEquipment(state, payload) {
    state.registeredData = payload;
  },
  setSuccessObject(state, payload) {
    state.successObject = payload;
  }
};
const actions = {
  async loadCarMountEquipment(context) {
    const carMountEquipments = await carMountEquipmentRepository.list();
    if (carMountEquipments.status < 300) {
      context.commit("setCarMountEquipment", carMountEquipments.data);
    }
  },
  async entryCarMountEquipment(context, payload) {
    const requestParameter = {
      equipment_id_list: payload.equipment_id_list,
      modified_hash: payload.modified_hash
    };
    const carMountEquipments = await carMountEquipmentRepository.entry(
      payload.screenId,
      requestParameter
    );
    if (carMountEquipments.status < 300) {
      context.commit("setRegisteredCarMountEquipment", carMountEquipments.data);
      context.commit("setSuccessObject", carMountEquipments);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
